export default __webpack_public_path__ + "static/media/spaces.2036ecd6.svg";